import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import QuestionAnswerComponent, {Question} from "../../../../components/help/QuestionAnswerComponent.tsx";

const questions: Question[] = [
    {
        question: "Fibernet",
        answer: <>
            <p>
                Har du allerede fibernet på adressen i dag, så er leveringstiden ca. 2-3 uger.
            </p>
            <p>
                Hvis du ikke har fiber på adressen, så er leveringen længere, da du skal have etableret fiberen ind til huset, før du kan komme online.
                Det tager oftest 4-6 uger, fra du bestiller fiber, til det er klar.
                Leveringstiden afhænger af, om du skal have besøg af en tekniker og en entreprenør, hvornår de kan komme ud til dig og hvor lang tid det tager at grave fiberen ind til din bolig.
            </p>
        </>
    },
    {
        question: "5G-internet",
        answer: <>
            <p>
                Det er super nemt at få 5G-internet!
                Du kan bestille allerede i dag og være online om 4 hverdage.
            </p>
        </>
    },
    {
        question: "Bredbånd via kabel-tv-stikket",
        answer: <>
            <p>
                Oftest går der 2-3 uger fra du bestiller, til dit nye internet er klar.
                Leveringstiden afhænger af, om du skal have besøg af en tekniker og hvornår teknikeren kan besøge dig.
            </p>
        </>
    },
]

export default function LeveringsTidArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article article--connect">
                    <div className="paragraph">
                        <p>
                            Leveringstiden på dit internet afhænger af, hvilken teknologi du skal have.
                            Vælg din teknologi nedenfor for at læse mere.
                        </p>
                    </div>
                </div>
                <div className="article">
                    <h2>Vælg teknologi</h2>
                    <QuestionAnswerComponent questions={questions}/>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "bestilling",
                        "article": "fiber-installation",
                        "name": "Hvordan får jeg installeret fiber?"
                    },
                    {
                        "category": "bestilling",
                        "article": "kan-jeg-faa-1000-mbit",
                        "name": "Kan jeg få 1.000 Mbit?"
                    },
                    {
                        "category": "bestilling",
                        "article": "tekniker-ved-kabel-tv-stik",
                        "name": "Teknikerbesøg ved kabel-tv-stik"
                    },
                    {
                        "category": "udstyr",
                        "article": "hvilken-router-foelger-med",
                        "name": "Hvilken router følger med?"
                    }
                ]}
            />
        </>
    )
}
